import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[am-layout-element]',
})
export class LayoutElementDirective {
  @HostBinding('style.visibility') display: 'visible' | 'hidden' = 'visible';
  @HostBinding('class') className = 'h-100';
  @Input() parentClass:
    | string
    | string[]
    | Set<string>
    | { [klass: string]: any };
}
